import React from "react"
import { Close } from "@icons"
import { ModalLayout } from "./ModalLayout"
import { useModalContext } from "./ModalContenxtProvider"

export const Modal = ({ children }) => {
  const { setIsModalOpen } = useModalContext()
  return (
    <ModalLayout>
      <div className="modal-content__header">
        <h2>Regisztráljon</h2>
        <button onClick={() => setIsModalOpen(false)}>
          <Close />
        </button>
      </div>
      {children}
    </ModalLayout>
  )
}
